export enum Gender {
  NONE = 'none',
  MEN = 'men',
  WOMEN = 'women',
}

export type AttentionsList = string[]

export interface PagerParams {
  perPage?: number
  page?: number
}

export interface PagerMeta {
  currentPage: number
  from: number
  lastPage: number
  perPage: number
  to: number
  total: number
}

export interface Response<Data> {
  data: Data
}

export interface ResponseWithMeta<Data, Meta> {
  data: Data
  meta: Meta
}

export type ApiResponse<Data, Meta = undefined> = Meta extends undefined
  ? Response<Data>
  : ResponseWithMeta<Data, Meta>

export enum DayOfWeek {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}
